import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import PATHS from "../../Routes/paths";

import { Button } from "@chakra-ui/react";
import { Title, WidgetLegend } from "../../Components/Atoms";
import { Donut } from "../../Components/Organisms/Graphs";
import { ArrowRightIcon, MotorIcon, MotorTempIcon } from "../../Assets/images/svgs";
import { MODULE_TYPES, STATS_ENUMS } from "../../Library/widgets";

const MotorTemperature = ({ data, enums }) => {
  const navigate = useNavigate();
  const parser = { x: "label", y: "count" };

  const graphData = useMemo(() => {
    return data.map((d) => {
      const status = enums[d.idx];
      return { label: status.label, count: d.count, color: status.color };
    });
  }, [ data, enums ]);

  return (
    <article className="widget-main">
      <header className="widget-header">
        <Title variant="md" fixed>Motor Temperature</Title>
      </header>

      <main className="widget-section">
        <div className="widget-chart">
          <Donut title="Motor Temperature" data={graphData} parser={parser} />
          <MotorTempIcon className="widget-chart-icon" />
        </div>

        <div className="widget-legend widget-legend-10">
          <WidgetLegend sparse data={graphData} parser={parser} />
        </div>

        <div className="widget-link">
          <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(PATHS.MOTOR_TEMPERATURE)}>
            View Reports
          </Button>
        </div>
      </main>
    </article>
  );
};

const MotorStatus = ({ data, enums }) => {
  const navigate = useNavigate();
  const parser = { x: "label", y: "count" };

  const graphData = useMemo(() => {
    return data.map((d) => {
      const status = enums[d.idx];
      return { label: status.label, count: d.count, color: status.color };
    });
  }, [ data, enums ]);

  return (
    <article className="widget-main">
      <header className="widget-header">
        <Title variant="md" fixed>Motor Status</Title>
      </header>

      <main className="widget-section">
        <div className="widget-chart">
          <Donut title="Motor Status" data={graphData} parser={parser} />
          <MotorIcon className="widget-chart-icon" />
        </div>

        <div className="widget-legend">
          <WidgetLegend data={graphData} parser={parser} />
        </div>

        <div className="widget-link">
          <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(PATHS.MOTOR_STATUS)}>
            View Reports
          </Button>
        </div>
      </main>
    </article>
  );
};

const MotorHealth = ({ data }) => {
  return (
    <div className="widget-group widget-2">
      <MotorTemperature data={data[MODULE_TYPES.MOTOR_TEMPERATURE] || []} enums={STATS_ENUMS[MODULE_TYPES.MOTOR_TEMPERATURE]} />
      <MotorStatus data={data[MODULE_TYPES.MOTOR_STATUS] || []} enums={STATS_ENUMS[MODULE_TYPES.MOTOR_STATUS]} />
    </div>
  );
};

export default MotorHealth;
